"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameStates = void 0;
const Language_1 = require("../../lang/Language");
class GameStates {
    static isPreGame(s) {
        return s.tag === 'pregame';
    }
    static isReadyToPlay(s) {
        return s.tag === 'readytoplay';
    }
    static isPlaying(s) {
        return s.tag === 'playing';
    }
    static isReset(s) {
        return s.tag === 'reset';
    }
    static isPaused(s) {
        return s.tag === 'paused';
    }
    static isFinished(s) {
        return s.tag === 'finished';
    }
}
exports.GameStates = GameStates;
GameStates.PreGame = {
    tag: 'pregame',
    description: Language_1.Language.strings.states.game.pregame,
};
GameStates.ReadyToPlay = {
    tag: 'readytoplay',
    description: Language_1.Language.strings.states.game.readytoplay,
};
GameStates.Playing = {
    tag: 'playing',
    description: Language_1.Language.strings.states.game.playing,
};
GameStates.Reset = {
    tag: 'reset',
    description: Language_1.Language.strings.states.game.reset,
};
GameStates.Paused = {
    tag: 'paused',
    description: Language_1.Language.strings.states.game.paused,
};
GameStates.Finished = {
    tag: 'finished',
    description: Language_1.Language.strings.states.game.finished,
};
//# sourceMappingURL=GameState.js.map